// extracted by mini-css-extract-plugin
export var deleteIcon = "_s5-5";
export var deleteOption = "_s5-3";
export var divider = "_s5-2";
export var downloadIcon = "_s5-4";
export var drawer = "_s5-0";
export var drawerFooter = "_s5-6";
export var drawerOpen = "_s5-1";
export var highlighted = "_s5-7";
export var lighterHighlight = "_s5-8";